/* eslint-disable prettier/prettier */
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import {reducer as formReducer} from 'redux-form';
import thunk from 'redux-thunk';

// Import reducers

// Build middleware
const middleware = compose(applyMiddleware(thunk));

// Combine the reducers
const reducers = combineReducers({
  form: formReducer,
});

// Make our store with our reducers and middleware
const store = createStore(reducers, middleware);

export default store;
